import { motion } from 'framer-motion';

interface BlogHeroProps {
  searchQuery: string;
  onSearchChange: (value: string) => void;
  totalArticles: number;
}

const BlogHero = ({ searchQuery, onSearchChange, totalArticles }: BlogHeroProps) => {
  return (
    <section className="relative bg-[#0A1628] text-white pt-40 pb-16 md:pt-40 md:pb-28 overflow-hidden">
      <div
        className="absolute inset-0 opacity-10"
        style={{
          backgroundImage: 'radial-gradient(circle, #D4AF37 1px, transparent 1px)',
          backgroundSize: '30px 30px',
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[#0A1628]/60" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          {/* Breadcrumb */}
          <nav aria-label="breadcrumb" className="flex items-center justify-center gap-2 text-xs md:text-sm text-neutral-400 mb-4 md:mb-6">
            <a href="/" className="hover:text-[#D4AF37] transition-colors">Início</a>
            <i className="ri-arrow-right-s-line text-neutral-600" />
            <span className="text-[#D4AF37]">Blog</span>
          </nav>

          <span className="inline-block px-3 py-1 md:px-4 md:py-1.5 bg-[#D4AF37]/20 text-[#D4AF37] text-xs md:text-sm font-medium rounded-full mb-4 md:mb-5">
            Conteúdo Técnico Especializado
          </span>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold mb-4 md:mb-5 font-['Poppins']">
            Blog Técnico
          </h1>
          <p className="text-sm md:text-lg text-neutral-300 max-w-2xl mx-auto mb-8 md:mb-10">
            Artigos especializados sobre <strong className="text-white">AVCB</strong>, <strong className="text-white">CLCB</strong>, segurança do trabalho e perícias técnicas para Sorocaba e Campinas
          </p>

          {/* Campo de Busca */}
          <div className="max-w-xl mx-auto relative">
            <div className="absolute inset-y-0 left-4 flex items-center pointer-events-none">
              <i className="ri-search-line text-neutral-400 text-base md:text-lg" />
            </div>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => onSearchChange(e.target.value)}
              placeholder="Buscar artigos sobre AVCB, CLCB, segurança..."
              className="w-full pl-11 md:pl-12 pr-5 py-3 md:py-4 rounded-xl bg-white/10 border border-white/20 text-white placeholder-neutral-400 text-xs md:text-sm focus:outline-none focus:border-[#D4AF37] focus:bg-white/15 transition-all"
            />
            {searchQuery && (
              <button
                onClick={() => onSearchChange('')}
                className="absolute inset-y-0 right-4 flex items-center text-neutral-400 hover:text-white transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-base md:text-lg" />
              </button>
            )}
          </div>

          <p className="mt-3 md:mt-4 text-xs md:text-sm text-neutral-500">
            {totalArticles} {totalArticles === 1 ? 'artigo encontrado' : 'artigos encontrados'}
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default BlogHero;